// extracted by mini-css-extract-plugin
module.exports = {"pin":"_2MPCQ"};